export default class Resize {
    constructor() {
        this.init()
    }

    init() {
        this.resizeView()
    }

    resizeView() {
        const isSP = () => window.innerWidth <= 750
        const scaleContainer = document.querySelector('.l-screen')

        const onResize = () => {
            const offset = 0
            const wh = window.innerHeight
            const mh = scaleContainer.offsetHeight
            const rate = (wh - offset * 2) / mh

            scaleContainer.style.transform = `scale(${rate})`
            scaleContainer.setAttribute('data-scale', rate)
        }

        const resetPos = () => {
            scaleContainer.style.transform = 'none'
        }

        window.addEventListener('resize', () => {
            if (isSP()) {
                resetPos()
            } else {
                onResize()
            }
        })

        window.addEventListener('load', () => {
            !isSP() && onResize()
        })
    }
}
